import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=b21d6340&scoped=true&"
import script from "./Debt.vue?vue&type=script&lang=js&"
export * from "./Debt.vue?vue&type=script&lang=js&"
import style0 from "./Debt.vue?vue&type=style&index=0&id=b21d6340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21d6340",
  null
  
)

export default component.exports